module.exports = __webpack_public_path__ + "img/bg_link_expo.db0d49e2.png";